import { _cropImage, ICropImage } from './DexeroModal/_cropImage';
import {
  _getDataForViewDataModal,
  IGetDataForViewDataModal,
} from './DexeroModal/_getDataForViewDataModal';
import {
  _getImageForCropImageModal,
  IGetImageForCropImageModal,
} from './DexeroModal/_getImageForCropImageModal';
import {
  _getImageForViewImageModal,
  IGetImageForViewImageModal,
} from './DexeroModal/_getImageForViewImageModal';
import { _getPasswordContent, IGetPasswordContent } from './DexeroModal/_getPasswordContent';
import { _modalBindings, IModalBindings } from './DexeroModal/_modalBindings';
import { _resetCropImageModal, IResetCropImageModal } from './DexeroModal/_resetCropImageModal';
import { _resetViewDataModal, IResetViewDataModal } from './DexeroModal/_resetViewDataModal';
import { _resetViewImageModal, IResetViewImageModal } from './DexeroModal/_resetViewImageModal';
import { confirmUserAction, IConfirmUserAction } from './DexeroModal/confirmUserAction';
import {
  handleViewDataModalClick,
  IHandleViewDataModalClick,
} from './DexeroModal/handleViewDataModalClick';
import { IResetUserPassword, resetUserPassword } from './DexeroModal/resetUserPassword';
import setupModal, { ISetupModal } from './DexeroApp/setupModal';
import trapTabKeyInModal, { ITtrapTabKeyInModal } from './DexeroApp/trapTabKeyInModal';

export interface IDexeroModals {
  _cropImage: ICropImage;
  _getDataForViewDataModal: IGetDataForViewDataModal;
  _getImageForCropImageModal: IGetImageForCropImageModal;
  _getImageForViewImageModal: IGetImageForViewImageModal;
  _getPasswordContent: IGetPasswordContent;
  _modalBindings: IModalBindings;
  _resetCropImageModal: IResetCropImageModal;
  _resetViewDataModal: IResetViewDataModal;
  _resetViewImageModal: IResetViewImageModal;
  confirmUserAction: IConfirmUserAction;
  handleViewDataModalClick: IHandleViewDataModalClick;
  resetUserPassword: IResetUserPassword;
  setupModal: ISetupModal;
  trapTabKeyInModal: ITtrapTabKeyInModal;
}

const DexeroModals: IDexeroModals = {
  // Crop image
  _cropImage,

  // Fetch data for data view
  _getDataForViewDataModal,

  // Fetch image for cropper
  _getImageForCropImageModal,

  // Fetch image for view
  _getImageForViewImageModal,

  // Get content on temp password / change password button click
  _getPasswordContent,

  _modalBindings,

  // Reset crop image modal
  _resetCropImageModal,

  // Reset view data modal
  _resetViewDataModal,

  // Reset view image modal
  _resetViewImageModal,

  // Replace regular JavaScript Prompt with Boostarap
  confirmUserAction,

  // Show ajax loaded data in view modal
  handleViewDataModalClick,

  // Reset password on button click
  resetUserPassword,

  // Setup modal
  setupModal,

  // Trap tab key into modal
  trapTabKeyInModal,
};
export default DexeroModals;
